import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * Format: "CrewCast | [Page Name]"
 */
export function usePageTitle(pageTitle: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = pageTitle ? `CrewCast | ${pageTitle}` : 'CrewCast';
    
    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle]);
}

export default usePageTitle;
